import(/* webpackMode: "eager" */ "/vercel/path0/app/components/web/guide.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/forgot-password/ForgotPasswordForm.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.35_@babel+core@7.28.0_@opentelemetry+api@1.9.1_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.35_@babel+core@7.28.0_@opentelemetry+api@1.9.1_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/next/dist/client/link.js");
